<div class="configuration-input-container">
  <form [formGroup]="textareaInput">
    <div
      (click)="textarea.focus()"
      class="text-area-container global-transition"
      [ngClass]="{
        'invalid-textarea': submitted && configForm.textarea.invalid,
        'focused-input-default': isFocused
      }">
      <label for="textarea" class="global-transition" [ngClass]="{'new-campaign': newCampaignMode}">
        <span *ngIf="!noLabel">{{ fieldInfo?.translations ? fieldName : ( 'view_translations.' + inputName | translate ) }}</span>
        <textarea
          #textarea
          (blur)="onInputBlur()"
          (focus)="isFocused = true"
          autofocus="{{autoFocus}}"
          (change)="getValue()"
          [ngClass]="{'invalid-textarea': submitted && configForm.textarea.invalid && ((configForm.textarea.dirty || configForm.textarea.touched) || requiredValue) && !isFocused,
          'monospace': fontFamily==='monospace'}"
          class="description-textbox global-transition"
          name="textarea"
          id="textarea"
          placeholder="{{ 'view_translations.' + ( placeholder ? placeholder : 'input_label') | translate }}"
          formControlName="textarea">
        </textarea>
      </label>
      <ng-container *ngFor="let name of fieldInfo?.translations">
        <div class="inner-container-right" *ngIf="name.lang === panelLanguage && name.help && !toolTipContent">
          <div class="tooltip-button tool-tip" [ngbTooltip]="name.help" container="body" placement="top-right" tooltipClass="my-configurations-tooltip">
            <nb-icon icon="info" pack="icomoon"></nb-icon>
          </div>
        </div>
      </ng-container>
      <div *ngIf="newCampaignMode && toolTipContent" class="inner-container-right">
        <div class="tooltip-button tool-tip" [ngbTooltip]="toolTipContent" container="body" placement="top-right" tooltipClass="my-configurations-tooltip">
          <nb-icon icon="info" pack="icomoon"></nb-icon>
        </div>
      </div>
    </div>
    <div class="error-text" id="errorTextContainer" *ngIf="(submitted || inputLengthChecked)  && configForm.textarea.invalid">
      <small class="form-text text-danger" *ngIf="submitted && configForm.textarea.errors?.required">
        {{ 'view_translations.this_field_is_required' | translate }}
      </small>
      <small class="form-text text-danger" *ngIf="configForm.textarea.errors?.minlength">
        {{ 'view_translations.min_input_length' | translate:minLength }}
      </small>
    </div>
  </form>
</div>
